import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { inject } from '@ember/service';
import { action, set } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("{{!\n  [regression-fix] CAT-7 — the old `action \'checkChange\'` Classic helper, when re-evaluated\n  during a Glimmer re-render triggered by @tracked checked changing, invoked checkChange as a\n  side-effect inside the render computation. checkChange calls notifyChecked which sets\n  @tracked checkedItems, but checkedItems was already consumed in the same computation by\n  indexContext.isCheck in base-index → \"You attempted to update checkedItems in the same\n  computation\" assertion. Replaced with this.checkChange: a plain bound-method reference\n  with no evaluation side-effects.\n}}\n{{!\n  Forward attributes to the checkbox BbCheckbox renders. Without this, anything a host\n  puts on <BbListCheckbox ...> — a data-test hook above all — is dropped here and never\n  reaches an element, so a select-all control looks wired and cannot be driven at all.\n  BbCheckbox splats onto its own root, so the attribute lands on the real checkbox.\n}}\n<BbCheckbox\n  data-test-check-change\n  @setContent={{fn (mut this.checked)}}\n  @content={{this.checked}}\n  @action={{this.checkChange}}\n  ...attributes\n/>");

var _dec, _class, _descriptor, _descriptor2;
let BbListCheckboxComponent = (_dec = inject('index-context'), _class = class BbListCheckboxComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "indexContext", _descriptor, this);
    // [regression-fix] CAT-4 — template binds @content={{this.checked}} and mutates via
    // (mut this.checked); without @tracked the template never re-renders on state change.
    _initializerDefineProperty(this, "checked", _descriptor2, this);
  }
  checkChange(checkItemInput) {
    if (Array.isArray(this.args.content)) {
      this.args.content.forEach(i => set(i, 'checked', checkItemInput));
      this.indexContext.notifyChecked();
      // Optional hook for callers whose @content rows are plain objects (not
      // Ember Data records): mutating `checked` above doesn't invalidate their
      // tracked array, so they need a signal to reassign/refresh it.
      this.args.onChange?.(checkItemInput);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "indexContext", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "checked", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "checkChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "checkChange"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, BbListCheckboxComponent);

export { BbListCheckboxComponent as default };
//# sourceMappingURL=bb-list-checkbox.js.map
